import { useCallback, useMemo, useState} from "react";
import { useParams } from "react-router-dom";

import PageTab from "components/common/pageTab";
import TopImage from "components/common/topImage";
import BrandList from 'components/brand/brandList';

import {pageMenuTabList05} from 'types/common';
import 'assets/css/brand.scss';

const PAGE_BRAND_LIST = [
  { code: "01", text: "천심본",       pcImg: "brand-chunsimbon_1240x400.jpg.jpg",     moImg: "m-brand-chunsimbon_500x400.jpg.jpg",    extraClass: "chunsimbon", desc: "강원인삼농협과 100% 계약재배된 6년근 홍삼을\n뉴질랜드산 녹용 등 귀한 원료를 바르게 담았습니다." },
  { code: "02", text: "프리미엄",     pcImg: "brand-premium_1240x400.jpg.jpg",         moImg: "m-brand-premium_500x400.jpg.jpg" },
  { code: "04", text: "하루활력",     pcImg: "brand-dayvitality_1240x400.jpg.jpg",     moImg: "m-brand-dayvitality_500x400.jpg.jpg" },
  { code: "06", text: "액티브솔루션", pcImg: "brand-activesolution_1240x400.jpg.jpg",  moImg: "m-brand-activesolution_500x400.jpg.jpg" },
  { code: "05", text: "데일리코어",   pcImg: "brand-dailycore_1240x400.jpg.jpg",       moImg: "m-brand-dailycore_500x400.jpg.jpg" },
  { code: "07", text: "아이키쑤욱",   pcImg: "brand-ikeyssuki_1240x400.jpg.jpg",       moImg: "m-brand-ikeyssuk_500x400.jpg.jpg" },
  { code: "10", text: "1005키디",     pcImg: "brand-1005kidi_1240x400.jpg.jpg",        moImg: "m-brand-1005kidi_500x400.jpg.jpg" },
  { code: "11", text: "퓨어",     pcImg: "brand-pure_1240x400.jpg.jpg",        moImg: "m-brand-pure_500x400.jpg.jpg" },
];

const BASE_URL = "https://img.chunhomall.com/images/brand_site/";

function Brand() {

  const { brandId } = useParams<{ brandId: string }>();
  
  pageMenuTabList05[0].on = true;
  
  const [strType] = useState<string>("B");
  // ✅ 초기값을 첫 번째 탭 코드로 설정 ("00" → "01")
  const [strProductBrandCode, setStrProductBrandCode] = useState<string>(
    brandId ?? PAGE_BRAND_LIST[0].code
  );

  const onClickTab = useCallback((code: string) => {
    setStrProductBrandCode(code);
  }, []);

  // ✅ pageBrandListProp이 외부 상수라 의존성에서 제거 가능
  const brandTabs = useMemo(
    () =>
      PAGE_BRAND_LIST.map((item) => (
        <div
          key={item.code}
          className={`tab ${item.code === strProductBrandCode ? "on" : ""}`}
          onClick={() => onClickTab(item.code)}
        >
          {item.text}
        </div>
      )),
    [strProductBrandCode, onClickTab]
  );

  return (
    <div className="page_content">
      <TopImage imgUrl="https://img.chunhomall.com/images/brand_site/brand-hero_1920x1080.jpg.jpg" imgText="브랜드 소개" textcolor="#FFF"></TopImage>
      <PageTab props={pageMenuTabList05}></PageTab>
          
      <div className="container brand">
        <div className="container-title">
          천호엔케어 브랜드와 대표제품을 소개합니다.
        </div>
        <div className="page-inner-tab">
          <div className="tabs">
            {brandTabs}
          </div>
        </div>
        
        {/* 브랜드 로고 + 설명 */}
        <div className="page-inner-tab" style={{ margin: "0 auto 50px auto"}}>
          {PAGE_BRAND_LIST.map((item) => (
            <div
              key={item.code}
              className={`tab-list ${item.code === strProductBrandCode ? "on" : ""}`}
            >
              <div className={`brand-logo ${item.extraClass ?? ""}`}>
                {item.pcImg && (
                  <div className="brand-logo-img">
                    <img src={`${BASE_URL}${item.pcImg}`} alt="brand Image" />
                  </div>
                )}
                {item.moImg && (
                  <div className="brand-logo-mo-img">
                    <img src={`${BASE_URL}${item.moImg}`} alt="brand Image" />
                  </div>
                )}
                {item.desc && (
                  <div className="brand-logo-text">
                    {item.desc.split("\n").map((line, i) => (
                      <span key={i}>{line}<br /></span>
                    ))}
                  </div>
                )}
              </div>
            </div>
          ))}
        </div>
        <div>
            <BrandList strType={strType} strProductBrandCode={strProductBrandCode} />
        </div>
      </div>
    </div>
  );
}

export default Brand;